import * as React from "react";
import FormikInput from "./FormikInput";
const FormikFormGroup = ({
  children = void 0,
  disabled = false,
  required = false,
  validate = () => void 0,
  autoFocus = false,
  labelClassName = "col-sm-3",
  wrapperClassName = "col-sm-9",
  label,
  name,
  onChange = void 0,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  FormikInput,
  {
    ...rest,
    disabled,
    required,
    validate,
    autoFocus,
    label,
    id: name,
    onChange,
    name,
    labelClassName,
    wrapperClassName
  },
  children
);
export default FormikFormGroup;
